export const MACHINE_TABLE_TYPE = 'MACHINE_TABLE_TYPE';
export const BACKUP_TABLE_TYPE = 'BACKUP_TABLE_TYPE';
export const INCOMPLETE_BACKUP_TABLE_TYPE = 'INCOMPLETE_BACKUP_TABLE_TYPE';
export const CONTENT_TABLE_TYPE = 'CONTENT_TABLE_TYPE';
export const UNDEFINED_CONTENT_TYPE = '';
